import { render, staticRenderFns } from "./EmployeeInput.vue?vue&type=template&id=51567024&"
import script from "./EmployeeInput.vue?vue&type=script&lang=js&"
export * from "./EmployeeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports